module.exports = __webpack_public_path__ + "static/img/product_08.3c68e6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_08.jpg
// module id = LL88
// module chunks = 2